import { render, staticRenderFns } from "./index.vue?vue&type=template&id=9127d0e8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=9127d0e8&prod&scoped=true&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=9127d0e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9127d0e8",
  null
  
)

export default component.exports